import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />

                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Contact Us
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    <section className="myContactPage contactUs_page">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Contact</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">Contact US</span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-6 col-sm-12">
                                    <div className="project-in-mind mb-30">
                                        <div className="title_div">
                                            <h2 className="section-heading">
                                                Get In Touch <br />
                                                With Us!
                                            </h2>
                                        </div>
                                        <div>
                                            <div className="contact_content">
                                                <figure>
                                                    <img
                                                        src="https://immensetek.com/wp-content/uploads/2022/07/location_3222642_termoffice20mappage1position3page1position3related_id3222642originsearch-1.png"
                                                        height={51}
                                                        width={51}
                                                        alt="image"
                                                        loading="lazy"
                                                    />
                                                </figure>
                                                <div className="contact_data">
                                                    <h4>India ITME Society,</h4>
                                                    <p>
                                                        1210/1211/1212 Dalamal Tower, ‘A’ Wing, 12th Floor, Plot
                                                        No.211, Nariman Point, Mumbai – 400 021, INDIA
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="contact_content">
                                                <figure>
                                                    <img
                                                        src="https://immensetek.com/wp-content/uploads/2022/07/phone-1.png"
                                                        height={51}
                                                        width={51}
                                                        alt="image"
                                                        loading="lazy"
                                                    />
                                                </figure>
                                                <div className="contact_data">
                                                    <h4>Contact Us</h4>
                                                    <p className="contact_p">
                                                        <i className="fas fa-phone-alt" /> +91-22-4972 4603
                                                    </p>
                                                    <p className="contact_p">
                                                        <i className="fas fa-mobile-alt" /> +91-8010 823 774 (For
                                                        Exhibition Queries)
                                                    </p>
                                                    <p className="contact_p">
                                                        <i className="fab fa-whatsapp" /> +91 7021089987 (For
                                                        Administration Queries)
                                                    </p>
                                                    <p className="contact_p">
                                                        <i className="far fa-envelope" /> itme@india-itme.com
                                                    </p>
                                                    <p className="contact_p">
                                                        <i className="fab fa-skype" /> indiaitme2012
                                                    </p>
                                                    <p className="contact_p">
                                                        <i className="fas fa-globe-europe" />
                                                        https://corporate.india-itme.com/
                                                    </p>
                                                </div>
                                            </div>
                                            {/* <p class="visit_class">Visit India ITME 2022 Virtual Booth</p> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12 order-md-2 mb-30">
                                    <div className="booking_query_main_div">
                                        <div className="booking_query_person_grid_view">
                                            <div>
                                                <p className="title">Stall Booking &amp; Operatiions Queries</p>
                                            </div>
                                            <div>
                                                <h6>Mr. Nitin Pachpande</h6>
                                                <p>+91 8010823774</p>
                                                <p>+91 2249724603 (India Office Number)</p>
                                                <p>projects@india-itme.com</p>
                                                <hr />
                                                <h6>Mr. Tushar A. Jayawant</h6>
                                                <p>+91 9820507570</p>
                                                <p>operations@india-itme.com</p>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="booking_query_person_grid_view">
                                            <div>
                                                <p className="title">Accounts Queries</p>
                                            </div>
                                            <div>
                                                <h6>Mr. Ammey Kuware</h6>
                                                <p>+91 8591951767</p>
                                                <p>accounts@india-itme.com</p>
                                                <hr />
                                                <h6>Mr. Nilesh Arondekar</h6>
                                                <p>+91 8169627107</p>
                                                <p>accounts03@india-itme.com</p>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="booking_query_person_grid_view">
                                            <div>
                                                <p className="title">
                                                    For Adminstration &amp; Registration Queries
                                                </p>
                                            </div>
                                            <div>
                                                <h6>Mr. Bhupendra Thakur</h6>
                                                <p>+91 7021089987</p>
                                                <p>admin@india-itme.com</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="booking_query_main_div">
                                        <div className="workingTime_grid_view">
                                            <div className="workingDays">
                                                <h6>Working days</h6>
                                                <p>Monday - Friday</p>
                                            </div>
                                            <div>
                                                <h6>Working Hrs</h6>
                                                <p>10:00 am to 06:00 pm, IST (GMT +05:30)</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="contact__area">
                        <div className="container">
                            <div className="row gutter-24">
                                <div className="col-lg-12">
                                    {/* contact-map */}
                                    <div className="contact-map">
                                        <iframe
                                            src="https://www.google.com/maps/embed/v1/place?q=India+ITME+Society&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                                            width={600}
                                            height={450}
                                            style={{
                                                border: "10px solid #fff",
                                                boxShadow: "0 1px 6px 0 rgba(32,33,36,0.28)"
                                            }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>


                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(contact));